"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingSpinner = void 0;

var _preact = require("preact");

var _assets = _interopRequireDefault(require("../../preact-components/assets"));

var LoadingSpinner = function LoadingSpinner(_ref) {
  var customClass = _ref.customClass,
      width = _ref.width,
      height = _ref.height,
      color = _ref.color;
  return (0, _preact.h)("div", {
    className: "loader-container"
  }, (0, _preact.h)(_assets.default, {
    icon: "loadingSpinner",
    width: width,
    height: height,
    color: color,
    customClass: "".concat(customClass !== null && customClass !== void 0 ? customClass : '', " icon-loading-spinner")
  }));
};

exports.LoadingSpinner = LoadingSpinner;